import React from 'react';
import "../../../assets/css/provacyterms.css"


export default class  GoTrainPrivacy extends React.Component {
  componentDidMount() {
    document.title = "Privacy"
  }

  render() {
    return (
      <html lang="en">
        <head>
          <meta charset="utf-8" />
          <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
          <title>Privacy Policy</title>
          <meta name="robots" content="noindex" />
          <link rel="apple-touch-icon-precomposed" sizes="57x57" href="/assets/images/apple-touch-icon-57x57.png" />
          <link rel="apple-touch-icon-precomposed" sizes="114x114" href="/assets/images/apple-touch-icon-114x114.png" />
          <link rel="apple-touch-icon-precomposed" sizes="72x72" href="/assets/images/apple-touch-icon-72x72.png" />
          <link rel="apple-touch-icon-precomposed" sizes="144x144" href="/assets/images/apple-touch-icon-144x144.png" />
          <link rel="apple-touch-icon-precomposed" sizes="60x60" href="/assets/images/apple-touch-icon-60x60.png" />
          <link rel="apple-touch-icon-precomposed" sizes="120x120" href="/assets/images/apple-touch-icon-120x120.png" />
          <link rel="apple-touch-icon-precomposed" sizes="76x76" href="/assets/images/apple-touch-icon-76x76.png" />
          <link rel="apple-touch-icon-precomposed" sizes="152x152" href="/assets/images/apple-touch-icon-152x152.png" />
          <link rel="icon" type="image/png" href="/assets/images/favicon-196x196.png" sizes="196x196" />
          <link rel="icon" type="image/png" href="/assets/images/favicon-96x96.png" sizes="96x96" />
          <link rel="icon" type="image/png" href="/assets/images/favicon-32x32.png" sizes="32x32" />
          <link rel="icon" type="image/png" href="/assets/images/favicon-16x16.png" sizes="16x16" />
          <link rel="icon" type="image/png" href="/assets/images/favicon-128x128.png" sizes="128x128" />
          <meta name="application-name" content="&nbsp;" />
          <meta name="msapplication-TileColor" content="#FFFFFF" />
          <meta name="msapplication-TileImage" content="/assets/images/mstile-144x144.png" />
          <meta name="msapplication-square70x70logo" content="/assets/images/mstile-70x70.png" />
          <meta name="msapplication-square150x150logo" content="/assets/images/mstile-150x150.png" />
          <meta name="msapplication-wide310x150logo" content="/assets/images/mstile-310x150.png" />
          <meta name="msapplication-square310x310logo" content="/assets/images/mstile-310x310.png" />

          <link href="/assets/css/live.css" rel="stylesheet" />
        </head>
        <body>
          <div class="wrapper py-5">
            <div class="page">
              <section class="sect-live">
                <div class="container">
                  <div class="row">
                    <div class="col-md-12">
                      <h1>Privacy Policy for Go Train</h1>
                      <p>At Go Train, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Go Train and how we use it.</p>
                      <p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.</p>
                      <h2>Log Files</h2>
                      <p> Go Train follows a standard procedure of using log files. These files log visitors when they use app. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the app, tracking users' movement on the app, and gathering demographic information.</p>
                      <h2>Our Advertising Partners</h2>
                      <p>Some of advertisers in our app may use cookies and web beacons. Our advertising partners are listed below. Each of our advertising partners has their own Privacy Policy for their policies on user data. For easier access, we hyperlinked to their Privacy Policies below.</p>
                      <ul>
                        <li>
                          <p>Google</p>
                          <p><a href="https://policies.google.com/technologies/ads">https://policies.google.com/technologies/ads</a></p>
                        </li>
                      </ul>
                      <h2>Privacy Policies</h2>
                      <p>You may consult this list to find the Privacy Policy for each of the advertising partners of Go Train.</p>
                      <p>Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Beacons that are used in their respective advertisements and links that appear on Go Train. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on this app or other apps or websites.</p>
                      <p>Note that Go Train has no access to or control over these cookies that are used by third-party advertisers.</p>
                      <h2>Third Party Privacy Policies</h2>
                      <p> Go Train's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.</p>
                      <h2>Children's Information</h2>
                      <p>Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.</p>
                      <p> Go Train does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our App, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.</p>
                      <h2>Online Privacy Policy Only</h2>
                      <p>This Privacy Policy applies only to our online activities and is valid for visitors to our App with regards to the information that they shared and/or collect in Go Train. This policy is not applicable to any information collected offline or via channels other than this app. </p>
                      <h2>Consent</h2>
                      <p>By using our app, you hereby consent to our Privacy Policy and agree to its Terms and Conditions.</p>
                      <h2>Contact Us</h2>
                      <p>Email: forterli@163.com</p>
                      <hr />
                    </div>
                  </div>
                </div>
              </section>
                {/* 中文翻译部分 */}
                <section class="sect-live" style={{marginTop: '40px'}}>
                  <div class="container">
                    <div class="row">
                      <div class="col-md-12">
                        <h1>随声练隐私政策</h1>
                        <p>在随声练，我们非常重视访问者的隐私。本隐私政策文件包含随声练收集和记录的信息类型以及我们如何使用这些信息。</p>
                        <p>如果您有其他问题或需要更多关于我们隐私政策的信息，请随时联系我们。</p>
                        <h2>日志文件</h2>
                        <p>随声练遵循使用日志文件的标准程序。当用户使用应用时，这些文件会记录访问者的信息。日志文件收集的信息包括互联网协议（IP）地址、浏览器类型、互联网服务提供商（ISP）、日期和时间戳、引用/退出页面以及可能的点击次数。这些信息不会与任何可识别个人身份的信息相关联。收集这些信息的目的是分析趋势、管理应用、跟踪用户在应用中的活动以及收集人口统计信息。</p>
                        <h2>我们的广告合作伙伴</h2>
                        <p>我们的应用中的某些广告商可能会使用 Cookie 和网络信标。我们的广告合作伙伴如下所列。每个广告合作伙伴都有自己的隐私政策，关于其用户数据的政策。为方便访问，我们在下方提供了他们的隐私政策链接。</p>
                        <ul>
                          <li>
                            <p>Google</p>
                            <p><a href="https://policies.google.com/technologies/ads">https://policies.google.com/technologies/ads</a></p>
                          </li>
                        </ul>
                        <h2>隐私政策</h2>
                        <p>您可以查阅此列表，了解随声练每个广告合作伙伴的隐私政策。</p>
                        <p>第三方广告服务器或广告网络可能会在其出现在随声练上的广告和链接中使用 Cookie、JavaScript 或网络信标等技术。当发生这种情况时，他们会自动获取您的 IP 地址。这些技术用于衡量其广告活动的有效性和/或个性化您在本应用或其他应用或网站上看到的广告内容。</p>
                        <p>请注意，随声练无法访问或控制第三方广告商使用的这些 Cookie。</p>
                        <h2>第三方隐私政策</h2>
                        <p>随声练的隐私政策不适用于其他广告商或网站。因此，我们建议您查阅这些第三方广告服务器的隐私政策，以获取更详细的信息。它们可能包括其做法和关于如何选择退出某些选项的说明。</p>
                        <h2>儿童信息</h2>
                        <p>我们非常重视儿童在使用互联网时的保护。我们鼓励家长和监护人观察、参与并/或监督和指导他们的在线活动。</p>
                        <p>随声练不会有意收集13岁以下儿童的任何个人身份信息。如果您认为您的孩子在我们的应用上提供了此类信息，请立即联系我们，我们将尽最大努力及时从我们的记录中删除这些信息。</p>
                        <h2>仅限在线隐私政策</h2>
                        <p>本隐私政策仅适用于我们的在线活动，并适用于访问我们应用的用户就其在随声练中分享和/或收集的信息。本政策不适用于通过线下或其他渠道收集的任何信息。</p>
                        <h2>同意</h2>
                        <p>通过使用我们的应用，您即表示同意我们的隐私政策并同意其条款和条件。</p>
                        <h2>联系我们</h2>
                        <p>邮箱：forterli@163.com</p>
                        <hr />
                      </div>
                    </div>
                  </div>
                </section>
            </div>
          </div>
        </body>
      </html>);
  }


}
